var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBabycare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 79.08 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Baby_care",
    x: 0,
    y: 0,
    width: 79.08,
    height: 98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Baby_care)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Baby_care-2",
    "data-name": "Baby care",
    d: "M99.74,63.035a1.169,1.169,0,0,0,.829-.343l.789-.789A1.172,1.172,0,0,0,99.7,60.245l-.789.789a1.172,1.172,0,0,0,.829,2ZM97.728,49.71l-.289.29A1.172,1.172,0,0,0,99.1,51.657l.289-.29a1.172,1.172,0,0,0-1.658-1.657ZM97.57,67.593a1.172,1.172,0,0,0-1.657,1.657l.938.938a1.172,1.172,0,0,0,1.657-1.657ZM80.332,57.868a1.172,1.172,0,1,0,1.657-1.657l-.817-.817a1.172,1.172,0,0,0-1.657,1.657Zm6.29,9.715-.957.957A1.172,1.172,0,0,0,87.323,70.2l.957-.957a1.172,1.172,0,0,0-1.657-1.658Zm-4.813-38.59a4.156,4.156,0,0,0,3.133-1.427,1.172,1.172,0,1,0-1.767-1.54,1.81,1.81,0,0,1-2.733,0,1.172,1.172,0,0,0-1.767,1.54A4.156,4.156,0,0,0,81.809,28.993Zm18.553,0a4.157,4.157,0,0,0,3.133-1.427,1.172,1.172,0,0,0-1.767-1.54,1.81,1.81,0,0,1-2.733,0,1.172,1.172,0,0,0-1.767,1.54,4.156,4.156,0,0,0,3.133,1.427Zm-7.537.874a1.743,1.743,0,1,0-1.74,1.855A1.8,1.8,0,0,0,92.825,29.868Zm20.4-10.3A23.48,23.48,0,0,0,89.839,4.524a2.822,2.822,0,0,1,2.743-2.181,1.172,1.172,0,0,0,0-2.344,5.168,5.168,0,0,0-5.145,4.759A23.792,23.792,0,0,0,77.315,8.772a1.172,1.172,0,1,0,1.34,1.923,21.454,21.454,0,0,1,9.073-3.61,6.17,6.17,0,0,0,5.851,4.237,1.172,1.172,0,0,0,0-2.344,3.82,3.82,0,0,1-3.42-2.125c12.15-.5,22.03,8.8,22.03,20.114,0,11.455-9.841,18.5-21.1,18.5-11.376,0-21.1-7.129-21.1-18.5a19.61,19.61,0,0,1,4.726-12.7,1.172,1.172,0,0,0-1.783-1.521,22.2,22.2,0,0,0-3.977,6.823,8.023,8.023,0,1,0,.585,15.979,19.98,19.98,0,0,0,6.8,7.911,17.152,17.152,0,0,0-1.989,4.569,3,3,0,0,0-1.388,2.156A18.432,18.432,0,0,0,72.8,52.6c0,7.021,1.009,15.25,5.147,20.891A15.661,15.661,0,0,0,91.086,80a15.876,15.876,0,0,0,11.179-4.277,1.172,1.172,0,1,0-1.614-1.7A14.273,14.273,0,0,1,79.836,72.1a18.621,18.621,0,0,1-2-3.517,72.515,72.515,0,0,1,28.357-13.856.637.637,0,0,1,.779.651c-.251,5.955-1.336,10.813-3.224,14.439a1.172,1.172,0,0,0,2.079,1.082c2.047-3.933,3.22-9.122,3.486-15.423a2.959,2.959,0,0,0-.88-2.244c0-.223,0-.433,0-.637a17.216,17.216,0,0,0-2.6-9.135,19.982,19.982,0,0,0,6.8-7.912,8.023,8.023,0,1,0,.588-15.979ZM62.89,27.585a5.687,5.687,0,0,1,5.352-5.67,20.923,20.923,0,0,0,.381,11.348A5.684,5.684,0,0,1,62.89,27.585Zm14.072,38.7A44.856,44.856,0,0,1,75.143,52.6a16.078,16.078,0,0,1,.138-2.1.667.667,0,0,1,.839-.558,87.1,87.1,0,0,1,17.04,6.692,75.9,75.9,0,0,0-16.2,9.656Zm29.126-13.9a3.027,3.027,0,0,0-.428.067,70.821,70.821,0,0,0-9.733,3.033,87.322,87.322,0,0,0-19.036-7.761,14.824,14.824,0,0,1,1.443-3.026,27.6,27.6,0,0,0,25.507,0,14.88,14.88,0,0,1,2.248,7.688Zm7.461-19.116a21.013,21.013,0,0,0,.387-11.348,5.679,5.679,0,0,1-.387,11.348Z",
    transform: "translate(-51.55 6)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabycare);
export default __webpack_public_path__ + "static/media/Baby care.a5a67d2044b11d198a368fedcfb094dc.svg";
export { ForwardRef as ReactComponent };